import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import world from '../../images/RegionWorld.png';

import './styles.scss';
import { useTranslation } from '@common/hooks/translation';
import { ascAlphabeticalSort } from '@common/helpers/declarative/sortings';

export const RegionList = ({ list, activeTab, routePrefix }) => {
  const t = useTranslation();
  const { sportType, regionAlias } = useParams();
  const navigate = useNavigate();

  if (!list) return null;

  const allCount = list[0]?.gameCount ? list.reduce((acc, item) => acc + item.gameCount, 0) : list.length;

  const seenKeys = new Set();

  const filteredRegions = list?.reduce((acc, item) => {
    const key = `${item.region_alias || item.RegionAlias}-${item.regionId || item.RegionId}`;

    if (!seenKeys.has(key)) {
      seenKeys.add(key);

      const resultCount = list.reduce(
        (n, regionItem) => ((regionItem.regionId || regionItem.RegionId) === (item.regionId || item.RegionId) ? n + 1 : n),
        0,
      );

      acc.push({
        regionAlias: item.region_alias || item.RegionAlias,
        regionId: item.regionId || item.RegionId,
        count: activeTab === 'upComing' ? item.gameCount : resultCount,
      });
    }

    return acc;
  }, []);

  const onRegionCLick = (regionAlias, activeTab, routePrefix) => {
    if (!regionAlias) {
      navigate(
        `${routePrefix}/racings/${sportType}/${activeTab}`,
      );
    } else {
      navigate(
        `${routePrefix}/racings/${sportType}/${activeTab}/${regionAlias}/`,
      );
    }
  };

  return (
    <div className="racing-region-wrapper">
      <div className="racing-region-list">

        {list.length !== 0 && <div
          className={`racing-region-item ${(!regionAlias || regionAlias === 'World') && 'active'}`}
          onClick={() => {
            onRegionCLick('', activeTab, routePrefix);
          }}
        >
          <div className="all-world">
            <img src={world} alt="" />
            <span className="racing-region-info">{t('All')}</span>
          </div>
          <div>
            <span className="count">{allCount}</span>
            <i className="global-icon racing-section-icon icon-slim-arrow-right" />
          </div>
        </div>}

        {filteredRegions?.sort(ascAlphabeticalSort('regionAlias')).filter((item) => item.count > 0).map((item) => (
          <div
            key={item.regionId}
            className={`racing-region-item ${regionAlias === item.regionAlias && 'active'}`}
            onClick={() => {
              onRegionCLick(item.regionAlias, activeTab, routePrefix);
            }}
          >
            <div>
              <span
                className={`flag icon-${item.regionAlias?.toLowerCase().replaceAll(' ', '')} flag`}
              />
              <span className="racing-region-info">{t(item.regionAlias)}</span>
            </div>
            <div>
              <span className="count">
                {item.count}
                {' '}
              </span>
              <i className="global-icon racing-section-icon icon-slim-arrow-right" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
